import { render, staticRenderFns } from "./ResSuccess.vue?vue&type=template&id=e7da6dfe&scoped=true&lang=pug"
import script from "./ResSuccess.vue?vue&type=script&lang=js"
export * from "./ResSuccess.vue?vue&type=script&lang=js"
import style0 from "./ResSuccess.vue?vue&type=style&index=0&id=e7da6dfe&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7da6dfe",
  null
  
)

export default component.exports